import React, { useEffect } from 'react';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../../components/SelectTwo';
import { setCleanInputError, setCleanTextAreaError } from '../../../../../../../utils/utils';
import useHandleErrorFields from '../../../../../../../hooks/useHandleErrorFields';

import { Depot } from '../../../../../../../app/models/Depot';
import { Product } from '../../../../../../../app/models/Product';
import { Currency } from '../../../../../../../app/models/Currency';
import { Unit } from '../../../../../../../app/models/Unit';
import { WarehouseQuoteRateDataForm } from '../../../../../../../app/models/WareHouseQuoteRates';

interface WarehouseQuoteRateFormProps {
  rateForm: WarehouseQuoteRateDataForm;
  setRateForm: (form: WarehouseQuoteRateDataForm) => void;
  disableUpdate?: boolean;
  errorFields?: any;
  depots: Depot[];
  products: Product[];
  currencies: Currency[];
  units: Unit[];
}

const WarehouseQuoteRateForm = ({
  rateForm,
  setRateForm,
  disableUpdate = false,
  errorFields,
  depots,
  products,
  currencies,
  units
}: WarehouseQuoteRateFormProps) => {
  const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

  useEffect(() => {
    setErrors(errorFields);
  }, [errorFields]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setRateForm({ ...rateForm, [name]: value });
  };

  const handleChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setRateForm({ ...rateForm, [name]: value });
  };

  const handleChangeSelectTwo = (name: string, value: number | string | null) => {
    setRateForm({ ...rateForm, [name]: value });
  };

  return (
    <>
      {/* Almacén */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Almacén</label>
        <div className="col-md-9">
          <SelectTwo
            name="depot_id"
            id="depot_id"
            inputValue={rateForm.depot_id}
            options={SelectTwoMapperOptions(depots, 'id', ['name'])}
            hasError={fieldHasError('depot_id') !== ''}
            onChange={(opt: any) => handleChangeSelectTwo('depot_id', opt.value)}
            placeholder="Seleccione un almacén"
            disabled={disableUpdate}
            onFocus={() => onFocusRemove('depot_id')}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('depot_id')}
            </div>
        </div>
      </div>

      {/* Producto */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Producto</label>
        <div className="col-md-9">
          <SelectTwo
            name="product_id"
            id="product_id"
            inputValue={rateForm.product_id}
            options={SelectTwoMapperOptions(products, 'id', ['name'])}
            hasError={fieldHasError('product_id') !== ''}
            onChange={(opt: any) => handleChangeSelectTwo('product_id', opt.value)}
            placeholder="Seleccione un producto"
            disabled={disableUpdate}
            onFocus={() => onFocusRemove('product_id')}
          />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('product_id')}
            </div>

        </div>
      </div>

      {/* Tarifa por ingreso */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por ingreso (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                name="container_entry_fee"
                className={`form-control ${fieldHasError('container_entry_fee')}`}
                value={rateForm.container_entry_fee ?? ''}
                onChange={handleChange}
                placeholder="Valor"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_entry_fee')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                  {fieldErrorMessage('container_entry_fee')}
              </div>

            </div>
            <div className="col-3">
              <SelectTwo
                name="container_entry_fee_currency_id"
                id="container_entry_fee_currency_id"
                inputValue={rateForm.container_entry_fee_currency_id}
                options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
                hasError={fieldHasError('container_entry_fee_currency_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('container_entry_fee_currency_id', opt.value)
                }
                placeholder="Moneda"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_entry_fee_currency_id')}
              />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('container_entry_fee_currency_id')}
              </div>
            </div>
            <div className="col-3">
              <SelectTwo
                name="container_entry_fee_unit"
                id="container_entry_fee_unit"
                inputValue={rateForm.container_entry_fee_unit_id}
                options={SelectTwoMapperOptions(units, 'id', ['name'])}
                hasError={fieldHasError('container_entry_fee_unit_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('container_entry_fee_unit_id', opt.value)
                }
                placeholder="Unidad"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_entry_fee_unit_id')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('container_entry_fee_unit_id')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por día almacenaje */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por día almacenaje</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                name="daily_storage_fee"
                className={`form-control ${fieldHasError('daily_storage_fee')}`}
                value={rateForm.daily_storage_fee ?? ''}
                onChange={handleChange}
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('daily_storage_fee')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                  {fieldErrorMessage('daily_storage_fee')}
              </div>
            </div>
            <div className="col-3">
              <SelectTwo
                name="daily_storage_fee_currency_id"
                id="daily_storage_fee_currency_id"
                inputValue={rateForm.daily_storage_fee_currency_id}
                options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
                hasError={fieldHasError('daily_storage_fee_currency_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('daily_storage_fee_currency_id', opt.value)
                }
                placeholder="Moneda"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('daily_storage_fee_currency_id')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('daily_storage_fee_currency_id')}
              </div>
            </div>
            <div className="col-3">
              <SelectTwo
                name="daily_storage_fee_unit_id"
                id="daily_storage_fee_unit_id"
                inputValue={rateForm.daily_storage_fee_unit_id}
                options={SelectTwoMapperOptions(units, 'id', ['name'])}
                hasError={fieldHasError('daily_storage_fee_unit_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('daily_storage_fee_unit_id', opt.value)
                }
                placeholder="Unidad"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('daily_storage_fee_unit_id')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('daily_storage_fee_unit_id')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por salida */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por salida (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                name="container_exit_fee"
                className={`form-control ${fieldHasError('container_exit_fee')}`}
                value={rateForm.container_exit_fee ?? ''}
                onChange={handleChange}
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_exit_fee')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                  {fieldErrorMessage('container_exit_fee')}
              </div>
            </div>
            <div className="col-3">
              <SelectTwo
                name="container_exit_fee_currency_id"
                id="container_exit_fee_currency_id"
                inputValue={rateForm.container_exit_fee_currency_id}
                options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
                hasError={fieldHasError('container_exit_fee_currency_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('container_exit_fee_currency_id', opt.value)
                }
                placeholder="Moneda"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_exit_fee_currency_id')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                {fieldErrorMessage('container_exit_fee_currency_id')}
              </div>
            </div>
            <div className="col-3">
              <SelectTwo
                name="container_exit_fee_unit"
                id="container_exit_fee_unit"
                inputValue={rateForm.container_exit_fee_unit_id}
                options={SelectTwoMapperOptions(units, 'id', ['name'])}
                hasError={fieldHasError('container_exit_fee_unit_id') !== ''}
                onChange={(opt: any) =>
                  handleChangeSelectTwo('container_exit_fee_unit_id', opt.value)
                }
                placeholder="Unidad"
                disabled={disableUpdate}
                onFocus={() => onFocusRemove('container_exit_fee_unit_id')}
              />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                {fieldErrorMessage('container_exit_fee_unit_id')}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Comentarios */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Comentario adicional</label>
        <div className="col-md-9">
          <textarea
            name="additional_comments"
            className={`form-control ${fieldHasError('additional_comments')}`}
            value={rateForm.additional_comments ?? ''}
            onChange={handleChangeText}
            placeholder="Comentario adicional"
            onFocus={setCleanTextAreaError}
            disabled={disableUpdate}
          />
              <div className="invalid-feedback" style={{ display: 'flex' }}>
                {fieldErrorMessage('additional_comments')}
              </div>
        </div>
      </div>
    </>
  );
};

export default WarehouseQuoteRateForm;
